import { IonCol, IonGrid, IonIcon, IonModal, IonRow } from '@ionic/react';
import * as React from 'react';
import { useState } from 'react';
import './updateComponent.scss';
import HtmlParseComponent from '../../../pages/Menu/htmlParsingComponent';

export const UpdateComponent = (props: any) => {
  const { contentStackData } = props;
  const updatesData = contentStackData.data && contentStackData.data.getWebContent && contentStackData.data.getWebContent.webHomePage;
  const leftObj: any = updatesData && updatesData.entries[0];
  const rightObj: any = updatesData && updatesData.entries[1];
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {leftObj || rightObj ? (
        <>
          <IonGrid class="sni-update-wrapper" data-testid="sniUpdates" onClick={() => setShowModal(true)}>
            <IonRow>
              <IonCol size="8" className="section-left">
                <h3 className="updatesTitle">{updatesData.sectionTitle}</h3>
                {leftObj ? (
                  <>
                    <p className="updateDate">{leftObj.createdAt}</p>
                    <h4 className="updatesTitle title-update">{leftObj.title}</h4>
                    <div className="updateText">
                      <HtmlParseComponent richText={leftObj.description} isRichText={false} />
                    </div>
                  </>
                ) : null}
              </IonCol>
              <IonCol size="4" className="section-right">
                {rightObj ? (
                  <>
                    <h3 className="updatesTitle">&nbsp;</h3>
                    <h5 className="updateDate update-date-col">{rightObj.createdAt}</h5>
                    <div className="desc">
                      <HtmlParseComponent richText={rightObj.description} isRichText={false} />
                    </div>
                  </>
                ) : null}
              </IonCol>
            </IonRow>
          </IonGrid>
          <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)} cssClass="update-modal">
            <h3 className="update-modal-header">{updatesData.sectionTitle}</h3>
            <IonGrid className="update-modal-content">
              {leftObj ? (
                <IonRow>
                  <IonCol className="modal-content-section">
                    <p className="updateDate">{leftObj.createdAt}</p>
                    <h4 className="updatesTitle title-upldate">{leftObj.title}</h4>
                    <div className="updateText">
                      <HtmlParseComponent richText={leftObj.description} isRichText={false} />
                    </div>
                    <div className="updateText">
                      <HtmlParseComponent richText={leftObj.moreDescription} isRichText={false} />
                    </div>
                  </IonCol>
                </IonRow>
              ) : null}

              {rightObj ? (
                <IonRow>
                  <IonCol className="modal-content-section">
                    <h5 className="updateDate">{rightObj.createdAt}</h5>
                    <div className="desc">
                      <HtmlParseComponent richText={rightObj.description} isRichText={false} />
                    </div>
                    {rightObj.moreDescription && (
                      <div className="desc">
                        <HtmlParseComponent richText={rightObj.moreDescription} isRichText={false} />
                      </div>
                    )}
                  </IonCol>
                </IonRow>
              ) : null}
            </IonGrid>
            <IonIcon
              className="cancel-btn"
              src="assets/icon/modal-cancel.svg"
              onClick={() => setShowModal(false)}
            />
          </IonModal>
        </>
      ) : null}
    </>
  );
};
